import { useCallback, useEffect } from 'react';
import { type IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps.ts';
import { type IButtonActionExecAsyncService } from '../IButtonAction.ts';
import { useExecAsyncServiceAction } from './useExecAsyncServiceAction.ts';

export function ButtonActionExecAsyncServiceLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionExecAsyncService>,
) {
  const {
    action,
    buttonWidgetOptions,
    onClickSubject,
    widget,
    index,
    messageApi,
  } = props;

  const {
    serviceId,
    inputs,
    enableRequestMessage,
    enableSuccessMessage,
    requestMessage,
    successMessage,
  } = action;

  const handleAsyncAction = useExecAsyncServiceAction({
    basePath: buttonWidgetOptions.name,
    serviceId,
    inputs,
    widget,
    index,
    messages: {
      messageApi,
      enableRequestMessage,
      enableSuccessMessage,
      requestMessage,
      successMessage,
    },
  });

  const handleAction = useCallback(() => {
    handleAsyncAction();
  }, [handleAsyncAction]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
